import { put } from "@redux-saga/core/effects";
import axios from "axios";

import { SaveChangedFontsRequestActionType } from "./../types";
import { getFormFailure, saveChangedFontsSuccess } from "./../actionCreators";
import { IErrorType } from "./../../types/errors.d";
import { FormsService } from "./../../../services/forms";

export function* saveChangedFontsSaga({ payload }: SaveChangedFontsRequestActionType) {
    try {
        yield FormsService.saveUserFonts(payload);
        yield put(saveChangedFontsSuccess({}));
    } catch (error) {
        if (axios.isAxiosError(error))
            yield put(getFormFailure({ errorType: IErrorType.AXIOS, data: error.response?.data }));
        else yield put(getFormFailure({ errorType: IErrorType.NATIVE, data: error }));
    }
}
